import { toast } from "sonner";

import { ApiError } from "@/lib/api";

export function getErrorMessage(error: unknown, fallback: string): string {
  if (error instanceof ApiError) {
    if (
      error.status === 429 ||
      /too many requests/i.test(error.message) ||
      /throttler/i.test(error.message)
    ) {
      return "Too many requests. Please wait a moment and try again.";
    }
    return error.message || fallback;
  }
  if (error instanceof Error && error.message.trim()) {
    return error.message;
  }
  return fallback;
}

export function toastApiError(error: unknown, fallback: string): void {
  toast.error(getErrorMessage(error, fallback));
}
